/**
 * Converts a number to a fixed-point notation, removes the decimal point,
 * and returns it as an integer.
 *
 * @param {number} x - The number to be converted.
 * @param {number} decimals - The number of decimal places to include in the fixed-point notation.
 * @returns {number} The converted number as an integer without a decimal point.
 */
export const toFixedInt = (x: number, decimals: number): number => {
	if (decimals < 0) {
		decimals = 0;
	}
	return Number(x.toFixed(decimals || 0).replace('.', ''));
};
